<script lang="ts">import { stateIFrameHref } from "@infinitro/global";
import { onMount } from "svelte";
import { tweened } from "svelte/motion";
import Close from "./icons/close.svelte";
let href;
stateIFrameHref.subscribe((v) => href = v);
const opacity = tweened(0, { duration: 120 });
onMount(() => {
	const unsub = stateIFrameHref.subscribe((v) => {
		if (v) {
			document.body.style.overflow = "hidden";
			opacity.set(1);
		} else {
			document.body.style.overflow = "";
			opacity.set(0);
		}
	});
	return unsub;
});
function close() {
	stateIFrameHref.set(undefined);
}
</script>

{#if href}
	<div class="external-iframe-container" style="opacity: {$opacity}">
		<div class="external-iframe">
			<header class="external-iframe-header">
				<button on:click={close}><Close /></button>
			</header>

			<button on:click={close} class="external-iframe-button">
				<Close />
			</button>

			<iframe src={href} allow="autoplay; clipboard-write; encrypted-media; fullscreen; payment" />
		</div>
	</div>
{/if}

<style>
	.external-iframe-container {

    position: fixed;

    inset: 0px;

    z-index: 9999;

    display: flex;

    align-items: center;

    justify-content: center;

    background-color: var(--color-background-500)
}

	.external-iframe {

    position: relative;

    height: 100%;

    width: 100%
}

	@media (min-width: 768px) {

    .external-iframe {

        height: 100vh;

        width: 100vw
    }
}

	.external-iframe-header {

    display: flex;

    height: 3rem;

    align-items: center;

    justify-content: flex-end;

    --tw-bg-opacity: 1;

    background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

	@media (min-width: 768px) {

    .external-iframe-header {

        display: none
    }
}

	.external-iframe-header span {

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 500
}

	.external-iframe-header button {

    padding: 0.5rem;

    font-size: 1.25rem;

    line-height: 1.75rem;

    line-height: 1
}

	.external-iframe-button {

    position: absolute;

    top: -0.75rem;

    right: -0.75rem;

    margin: 1rem;

    display: none;

    height: 2rem;

    width: 2rem;

    border-radius: 9999px;

    background-color: var(--color-background-500);

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

	@media (min-width: 768px) {

    .external-iframe-button {

        display: block
    }
}

	.external-iframe iframe {

    height: calc(100% - 3rem);

    width: 100%;

    border-width: 0px;

    background-color: var(--color-background-500)
}

	@media (min-width: 768px) {

    .external-iframe iframe {

        height: 100%
    }
}
</style>
